import { formatBrDate } from "../../../../services/formatResponses/date";

export function displayValue(value, fallback = "Não informado") {
  if (value === null || value === undefined || value === "") return fallback;
  return value;
}

export const formatDate = formatBrDate;

export function formatAddress(address) {
  if (!address) return "Não informado";
  if (typeof address === "string") return address || "Não informado";

  const street = [address.street, address.number].filter(Boolean).join(", ");
  const neighborhood = address.neighborhood || "";
  const city = [address.city, address.uf].filter(Boolean).join(" - ");
  const postalCode = address.postalCode || address.zipCode || "";

  return [street, address.complement, neighborhood, city, postalCode]
    .filter(Boolean)
    .join(" · ") || "Não informado";
}

export function formatBoolean(value) {
  if (value === true) return "Sim";
  if (value === false) return "Não";
  return "Não informado";
}
